export const DUE_DATE_LIMIT = {
  'REQUEST FOR INFORMATION': 4,
  'AUDIT COMMENCEMENT DOCUMENTS': 4,
  'PRELIMINARY FINDINGS': 3,
  'FINALISATION ADVICE': 3,
};

export const RFI_DEFAULT_DUE_DATE = 14;
